import React from "react";
import styled from "styled-components";
import { GRAY_700, PRIMARY_600 } from "../../constant/colors";

const StyledDot = styled.span`
  border-radius: 50%;
  display: inline-block;
  height: 4px;
  width: 4px;
  background-color: ${GRAY_700};
  margin: 1px;
  :hover {
    background-color: ${PRIMARY_600};
  }
`;

const ThreeDots = () => {
  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <StyledDot />
      <StyledDot />
      <StyledDot />
    </div>
  );
};

export { ThreeDots };
